<template>
  <div class="chart">
    <div class="msg-content" ref="msgContent">
      <div class="top clearfix">
        <div class="fl"><img src="../../assets/images/chart-gpt.png"></div>
        <div class="fr">
          你好，我是人工智能Chart机器人，我可以回答你所有的问题，快来和我聊天吧！
        </div>
      </div>
      <div class="hot-ask" v-show="showHotAsk">
        <div class="hot-ask-top clearfix">
          <div class="fl">
            <img src="../../assets/images/hot-ask.png">
            <span>热门提问</span>
          </div>
          <div class="fr">
            <span>换一批</span>
            <img src="../../assets/images/refresh.png">
          </div>
        </div>
        <div class="hot-ask-container">
          <div class="ask-list" v-for="({ title }, index) in hotAskList" :key="index">{{ title }}</div>
        </div>
        <div class="look-more">
          <div class="l-line"><span></span></div>
          <div class="container">
            <span>查看更多</span>
            <img src="../../assets/images/look-more.png">
          </div>
          <div class="r-line"><span></span></div>
        </div>
      </div>
      <div class="QA-container">
        <div class="QA-list" v-for="(item, index) in QA_list" :key="index">
          <div class="Q-container clearfix">
            <div class="fr user-header">
              <img v-if="userheader" :src="userheader" alt="">
              <img v-else src="../../assets/images/df_header.png">
            </div>
            <div class="fr user-question">{{ item.question }}</div>
            <div class="fr c_container">
              <img
                src="../../assets/images/copy.png"
                v-clipboard:copy="item.question"
                v-clipboard:success="copyTextSuccess"
                v-clipboard:error="copyTextError"
              >
            </div>
          </div>
          <div class="A-container clearfix">
            <div class="fl chart-gpt"><img src="../../assets/images/chart-gpt.png"></div>
            <div class="fl chart-answers">
              <div class="chart-loading" v-show="item.loadingA"><van-loading size="18" type="spinner" /></div>
              <div class="chart-text" v-html="item.answers"></div>
            </div>
            <div class="fl p_c_container">
              <img v-if="item.answers === qWaiteText && !item.isPaste" @click="pasteAnswers(item, index)" src="../../assets/images/paste.png">
              <img
                v-else
                src="../../assets/images/copy.png"
                v-clipboard:copy="item.answers"
                v-clipboard:success="copyTextSuccess"
                v-clipboard:error="copyTextError"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <input type="text" placeholder="你想和我聊点什么？" v-model="value">
      <div class="submit-ico" @click="submitQ">
        <img src="../../assets/images/submit.png">
      </div>
    </div>
    <div class="msg-dialog" v-if="msgDialog.showMsg">
      <div>{{ msgDialog.msg }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Chart',
    data() {
      return {
        value: '',
        userheader: undefined,
        msgDialog: {
          showMsg: false,
          msg: '',
        },
        showHotAsk: false,
        qWaiteText: '思考中，请稍等...',
        hotAskList: [
          { title: '测试热门提问1', id: 1 },
          { title: '测试热门提问2', id: 2 },
          { title: '测试热门提问3', id: 3 }
        ],
        QA_list: []
      }
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      async getUserInfo() {
        let data = await $api.getPanel()
        if (data) {
          this.userheader = data.headImgUrl || undefined
        }
      },
      async submitQ() {
        let isCanQues = true
        if (this.QA_list.length > 0 && this.QA_list[this.QA_list.length - 1]['answers'] === this.qWaiteText && !this.QA_list[this.QA_list.length - 1]['isPaste']) {
          isCanQues = false
        }
        const QAObj = {
          answers: this.qWaiteText,
          question: this.value,
          isPaste: false,
          loadingA: true
        }
        if (isCanQues) {
          this.QA_list.push(QAObj)
          this.value = ''
          this.bottomScrollClick()
        }
        this.QAApi()
      },
      async QAApi () {
        let data = await $api.robotChat({ message: this.QA_list[this.QA_list.length - 1]['question'] })
        if (data) {
          this.QA_list[this.QA_list.length - 1]['answers'] = data
          this.QA_list[this.QA_list.length - 1]['isPaste'] = false
          this.QA_list[this.QA_list.length - 1]['loadingA'] = false
        }
        this.bottomScrollClick()
      },
      bottomScrollClick() {
        this.$nextTick(() => {
          let scrollEl = this.$refs.msgContent
          scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' })
        });
      },
      pasteAnswers(data, index) {
        let QAObj = {
          answers: this.qWaiteText,
          question: this.QA_list[this.QA_list.length - 1]['question'],
          isPaste: true,
          loadingA: false
        }
        this.$set(this.QA_list, index, QAObj)
      },
      copyTextSuccess() {
        this.msgDialog.showMsg = true
        this.msgDialog.msg = '复制成功，快去粘贴吧。'
        setTimeout(() => {
          this.resetCopyDialog()
        }, 1000)
      },
      copyTextError() {
        this.msgDialog.showMsg = true
        this.msgDialog.msg = '复制失败！'
        setTimeout(() => {
          this.resetCopyDialog()
        }, 1000)
      },
      resetCopyDialog() {
        this.msgDialog.showMsg = false
        this.msgDialog.msg = ''
      }
    }
  }
</script>

<style lang='less'>
  .chart {
    width: 100%;
    height: calc(100% - 40px - env(safe-area-inset-bottom));
    position: relative;
    .msg-content{
      width: 94%;
      height: calc(100% - 40px);
      overflow-y: auto;
      padding: 15px 3% 0;
      position: absolute;
      top: 0;
      bottom: 40px;
      font-size: 12px;
      .top{
        margin-bottom: 20px;
        .fl{
          width: 30px;
          vertical-align: top;
          margin-right: 5px;
          img{
            width: 100%;
            border-radius: 50%;
          }
        }
        .fr{
          vertical-align: top;
          line-height: 20px;
          padding: 5px 15px;
          border-radius: 8px;
          width: calc(100% - 35px);
          box-sizing: border-box;
          background-color: #f5f6fa;
        }
      }
      .hot-ask{
        margin-bottom: 10px;
        .hot-ask-top{
          font-size: 14px;
          margin-bottom: 10px;
          img{
            width: 18px;
            margin-right: 5px;
          }
          img,span{
            line-height: 18px;
            vertical-align: middle;
          }
          .fr{
            img{
              width: 12px;
              margin-left: 5px;
              margin-right: 0;
            }
          }
        }
        .hot-ask-container{
          .ask-list{
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 10px;
            background-color: #f5f6fa;
            border-radius: 5px;
            padding: 8px 12px;
            color: @colorDefault;
          }
        }
        .look-more{
          text-align: center;
          .l-line,.container,.r-line{
            display: inline-block;
            line-height: 20px;
          }
          .l-line,.r-line{
            width: calc(50% - 40px);
            span{
              width: 50%;
              display: inline-block;
              border: 1px solid #ccc;
              vertical-align: middle;
            }
          }
          .r-line{
            text-align: left;
          }
          .l-line{
            text-align: right;
          }
          .container{
            width: 80px;
            text-align: center;
            span,img{
              vertical-align: middle;
            }
            img{
              width: 14px;
            }
          }
        }
      }
      .QA-container{
        .QA-list{
          .Q-container,.A-container{
            margin-bottom: 15px;
          }
          .Q-container{
            padding-left: 30px;
            text-align: right;
            .user-header{
              width: 26px;
              line-height: 26px;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 100%;
                vertical-align: middle;
              }
            }
            .user-question{
              max-width: calc(100% - 90px);
              border-radius: 6px;
              padding: 6px 10px;
              background-color: #f5f6fa;
              line-height: 18px;
              margin-right: 8px;
              word-break: break-word;
            }
            .c_container{
              line-height: 33px;
              img{
                width: 20px;
                vertical-align: middle;
              }
            }
          }
          .A-container{
            .chart-gpt{
              width: 26px;
              vertical-align: top;
              margin-right: 5px;
              img{
                width: 100%;
                border-radius: 50%;
              }
            }
            .chart-answers{
              max-width: calc(100% - 110px);
              border-radius: 6px;
              padding: 6px 10px;
              background-color: #f5f6fa;
              line-height: 18px;
              margin-right: 8px;
              .chart-loading{
                width: 20px;
              }
              .chart-loading,.chart-text{
                display: inline-block;
                vertical-align: middle;
              }
              .chart-text{
                word-break: break-word;
              }
            }
            .p_c_container{
              line-height: 33px;
              img{
                width: 22px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .clearfix {
        zoom: 1;
        &:before,
        &::after {
          display: table;
          content: ' ';
        }
        &::after {
          clear: both;
          height: 0;
          font-size: 0;
          visibility: hidden;
        }
      }
      .fl{
        float: left;
      }
      .fr{
        float: right;
      }
    }
    .footer{
      width: 100%;
      height: 40px;
      position: absolute;
      bottom: 0;
      z-index: 99;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #efeded;
      input{
        width: 60%;
        height: 20px;
        font-size: 12px;
        padding: 5px 10px;
        outline: none;
        border: none;
        background-color: #f5f6fa;
        border-radius: 15px;
      }
      .submit-ico{
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background-color: @colorDefault;
        color: #fff;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 80%;
          height: 80%;
        }
      }
    }
    .msg-dialog{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 199;
      display: flex;
      align-items: center;
      justify-content: center;
      div{
        text-align: center;
        background-color: #f5f6fa;
        color: @colorDefault;
        border-radius: 10px;
        font-size: 12px;
        padding: 3px 15px;
      }
    }
  }
</style>
